import { OperationModes } from "@/apollo/types";

export function getOperationModeTooltip(mode: OperationModes) {
  switch (mode) {
    case OperationModes.Upsert:
      return "Insert new records and update existing ones";
    case OperationModes.Insert:
      return "Insert new records only";
    case OperationModes.Update:
      return "Update existing records only";
    case OperationModes.Mirror:
      return "Sync all records every time";
    default:
      return null;
  }
}
